import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

 
 

export default function DenseTable() {
  return (
    <TableContainer
     sx={{
        // width: '400px', 
        // height:'300',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.3)',
          padding:'3px',
          bgcolor:'#f1f8e9',
          borderRadius: '20px',
          display: 'flex',
       }} 
      component={Paper}>
      <Table  size="small" aria-label="a dense table" >
        <TableHead>
          <TableRow >
             
            <TableCell style={{fontWeight:'bold'}} >Type&nbsp;</TableCell>
            <TableCell style={{fontWeight:'bold'}} >Jobs In&nbsp;</TableCell>
            <TableCell style={{fontWeight:'bold'}} >Jobs Out&nbsp;</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
             <TableRow>
              <TableCell >MOT Jobs</TableCell>
              <TableCell style={{fontSize: 11, textAlign:'center'}} ><b>5</b></TableCell>
              <TableCell style={{fontSize: 11, textAlign:'center'}}><b>3</b></TableCell>
            </TableRow>
            <TableRow>
              <TableCell >Service Works</TableCell>
              <TableCell style={{fontSize: 11, textAlign:'center'}}><b>7</b></TableCell>
              <TableCell style={{fontSize: 11, textAlign:'center'}}><b>2</b></TableCell>
            </TableRow> <TableRow>
              <TableCell >Others Works</TableCell>
              <TableCell style={{fontSize: 11, textAlign:'center'}}><b>12</b></TableCell>
              <TableCell style={{fontSize: 11, textAlign:'center'}}><b>5</b></TableCell>
            </TableRow> <TableRow>
              <TableCell >Cash Jobs</TableCell>
              <TableCell style={{fontSize: 11, textAlign:'center'}}><b>12</b></TableCell>
              <TableCell style={{fontSize: 11, textAlign:'center'}}><b>12</b></TableCell>
            </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}